var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class CollectApi {
    constructor(baseURL, projectKey) {
        Object.defineProperty(this, "baseURL", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "projectSecret", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.baseURL = `${baseURL}/api/v1`;
        this.projectId = projectKey.id;
        this.projectSecret = projectKey.secret;
    }
    createTreesponder() {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new Request(`${this.baseURL}/treesponders`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "x-project-id": this.projectId,
                    "x-project-secret": this.projectSecret,
                },
            });
            return yield resolve(request);
        });
    }
    createTreesponse(treesponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new Request(`${this.baseURL}/treesponses`, {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    "x-project-id": this.projectId,
                    "x-project-secret": this.projectSecret,
                    authorization: `Bearer ${treesponse.treesponder.token}`,
                },
                body: JSON.stringify({
                    age: treesponse.age,
                    completed: treesponse.completed,
                    email: treesponse.email,
                    gender: treesponse.gender,
                    language: treesponse.language,
                    optin_organisation: treesponse.optinOrganisation,
                    option_project: treesponse.optinProject,
                    page_visits: treesponse.pageVisits,
                    postcode: treesponse.postcode,
                    survey_version: treesponse.surveyVersion,
                    year_of_birth: treesponse.yearOfBirth,
                    answers: treesponse.answers,
                    results: treesponse.results,
                }),
            });
            return yield resolve(request);
        });
    }
    updateTreesponse(treesponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = new Request(`${this.baseURL}/treesponses/${treesponse.id}`, {
                method: "PATCH",
                headers: {
                    "content-type": "application/json",
                    "x-project-id": this.projectId,
                    "x-project-secret": this.projectSecret,
                    authorization: `Bearer ${treesponse.treesponder.token}`,
                },
                body: JSON.stringify({
                    age: treesponse.age,
                    completed: treesponse.completed,
                    email: treesponse.email,
                    gender: treesponse.gender,
                    language: treesponse.language,
                    optin_organisation: treesponse.optinOrganisation,
                    option_project: treesponse.optinProject,
                    page_visits: treesponse.pageVisits,
                    postcode: treesponse.postcode,
                    survey_version: treesponse.surveyVersion,
                    year_of_birth: treesponse.yearOfBirth,
                    answers: treesponse.answers,
                    results: treesponse.results,
                }),
            });
            return yield resolve(request);
        });
    }
}
function resolve(request) {
    return __awaiter(this, void 0, void 0, function* () {
        let response, result;
        try {
            response = yield fetch(request);
            result = response.status === 204 ? true : yield response.json();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            const reason = {};
            reason[error.constructor.name] = error.message;
            throw reason;
        }
        if (response.ok) {
            return result;
        }
        else {
            throw result;
        }
    });
}
